export default __webpack_public_path__ + "static/template2-graphique-b0b7960c28878ee553810e672f4ac282.svg";